define('app/views/travel_hotel_details_view',['app/setup',
  'jquery.sumoselect',
  'app/lib/pwt/persian-date',
  'app/lib/pwt/persian-datepicker',
  'app/lib/lightslider',
  'app/collections/travel_hotel_collection'],
  function (takhfifan, persianDate, pdp) {
    takhfifan.travelHotelDetailsView = Backbone.View.extend({
      events: {
        "click .tkh-travel-hotel-room__upRoom": "upRoom",
        "click .tkh-travel-hotel-room__downRoom": "downRoom",
        "click .tkh-travel-hotel-room__reserve": "reserve",
        "click .tkh-travel-hotel-room__un-reserve": "unReserve",
        "click .tkh-hotel-details__reserve-btn": "submit",
        'submit form': 'searchFormSubmit'
      },

      template: ($('#travel-hotel-details-template').length > 0) ?
        _.template($('#travel-hotel-details-template').html()) : '',

      initialize: function () {
        window.persianDate = pdp;
        this.collection = new takhfifan.TravelHotelCollection;
        Backbone.Validation.bind(this);
        var _this = this;
        window.scrollTo(0, 0);

        var hotelDetailEl = $('.tkh-travel-hotel-details__content');
        this.hotelId = hotelDetailEl.data("hotel-id");
        this.cityId = hotelDetailEl.data("city-id");
        this.cityName = hotelDetailEl.data("city-name");


        // $('select.tkh-nights-in-detail-page').SumoSelect();

        takhfifan.eventHub.on('travel:persist-hotel', function (data) {
          this.persistData(data);
        }, this);

        takhfifan.eventHub.on('travel:hotel-render-rooms', function (collection) {
          takhfifan.eventHub.trigger('travel:persist-hotel', {hotels: collection.collection.toJSON()});

          this.renderHotelRooms(_this.hotelId);
          // $('.hotel-detail-loader').removeClass("show");
          $("#hotel__rooms").addClass("remove-loading");
          $("div.tkh-travel-hotel-details").parent().show();
          this.generateDatePickers();

          $(".el-in").html(_this.model.checkinJalali.replace(/\-/g, '/')).addClass('travel-search-types__form__dp--has-value');
          $("select.tkh-travel-hotel-search__number.nights-select-input").val(_this.model.nights).change();
        }, this);

        this.initSearchRooms();
        $(".el-in").html(this.model.checkinJalali.replace(/\-/g, '/')).addClass('travel-search-types__form__dp--has-value');
        var selectNightsEl = $('tkh-travel-hotel-search__number.nights-select-input').SumoSelect();
        selectNightsEl.val(this.model.nights).change();


        this.initGallery();

        //TODO: convert this to backbone model
        this.cartData = {
          hotelId: null,
          hotelAddress: "",
          hotelName: "",
          totalPrice: 0,
          rooms: 0,
          beds: 0,
          details: []
        };

        $(document).on('click', '.tkh-filter-rooms-search-btn', function (e) {
          e.preventDefault();
          $("#hotel__rooms").addClass("show-loading");
          _this.checkInDP = null;
          _this.checkOutDP = null;
          takhfifan.eventHub.trigger('travel:persist-hotel', {search: _this.model});
          _this.collection.fetch({
            dataType: 'json',
            data: {
              city_id: _this.model['cityId'],
              cityName: _this.model['cityName'],
              form_key: takhfifan.formKey
            },
            success: function (collection) {
              if (collection.models && collection.models.length > 0 && collection.hasOnline) {
                collection.getRoomDetails(_this.model, collection.models, 'travel:hotel-render-rooms');
              }
            },
            error: function () {
            },
            complete: function () {
            }
          });
        });

        $(document).on('change', '.tkh-nights-in-detail-page', function (e) {
          var $target = $(e.target);
          _this.model.nights = $target.find(":selected").val();
          _this.$('.tkh-filter-rooms-search-btn').removeAttr('disabled');


          var checkout = _this.generateDateFromString(_this.model.checkin, parseInt(_this.model.nights));
          _this.model['checkout'] = checkout.date;
          _this.model['checkoutJalali'] = checkout.jalali;

          _this.persistData({search: _this.model});

        });

        $(document).on('click', '.tkh-travel-checkout__action-back.tkh-hotel-back-btn', function (e) {
          takhfifan.eventHub.trigger('travel:disable');
          window.location.replace(window.location.href.split("#travel_view")[0]);
        });
      },


      initGallery:function(){
        $('#image-gallery').lightSlider({
          gallery: false,
          pager: false,
          item: 1,
          thumbItem: 0,
          slideMargin: 0,
          speed: 500,
          auto: true,
          loop: false,//TODO #NEXT set true after solve the bug
          onSliderLoad: function () {
            $('#image-gallery').removeClass('cS-hidden');
          }
        });

        takhfifan.eventHub.trigger('travel:enable');
      },

      initSearchRooms: function(){
        var url = window.location.href,
          params = null,
          checkinParam = null,
          nightsParam = null,
          _this = this;

        try {
          params = url.split("?")[1].split("&");
          if(params && params.length) {
            for (var i = 0; i < params.length; i++) {
              var item = params[i];
              if (item.includes('checkin')) {
                checkinParam = item.split("=")[1];
              }
              if (item.includes('nights')) {
                nightsParam = item.split("=")[1].slice(0,1);
              }
            }
          }
        }
        catch (e) {}

        this['model']= null;
        if (checkinParam && nightsParam) {
          var checkin = this.generateDateFromString(checkinParam, 0);
          var checkout = this.generateDateFromString(checkinParam, parseInt(nightsParam));
          this['model']= {
            checkin: checkin.date,
            checkinJalali: checkin.jalali,
            checkout: checkout.date,
            checkoutJalali: checkout.jalali,
            cityId: this.cityId,
            cityName: this.cityName,
            nights: nightsParam,
            person: 1,
          };
        }
        else {
          var checkin = this.generateDate(true, 0);
          var checkout = this.generateDate(false, 1);
          this['model'] = {
            checkin: checkin.date,
            checkinJalali: checkin.jalali,
            checkout: checkout.date,
            checkoutJalali: checkout.jalali,
            cityId: this.cityId,
            cityName: this.cityName,
            nights: 1,
            person: 1,
          };
        }

        this.persistData({search: this.model});

        this.collection.fetchJustOnlineHotels({
          dataType: 'json',
          data: {
            city_id: _this.model['cityId'],
            cityName: _this.model['cityName'],
            form_key: takhfifan.formKey
          },
          type:'online',
          success: function (collection) {
            if (collection.models && collection.models.length > 0 && collection.hasOnline) {
              collection.getRoomDetails(_this.model, collection.models, 'travel:hotel-render-rooms');
            }
          },
          error: function () {
          },
          complete: function () {
          }
        });
      },

      persistData: function (data) {
        var persistedData = Lockr.get("travelHotelData") || {};
        _.each(data, function (value, key) {
          persistedData[key] = value;
        });
        persistedData.time = new Date();
        Lockr.set("travelHotelData", persistedData);
      },

      // helper for date generation with 2 parameters that returns an object
      generateDate: function (isNow, whenFromNowInDays) {
        var unix = new Date();
        if (!isNow) {
          unix.setDate(unix.getDate() + whenFromNowInDays);
        }
        var selectedDateText = this.formatDate(unix),
          selectedDateJalali = new pdp(unix).format("YYYY-MM-DD");

        return {date: selectedDateText, jalali: selectedDateJalali};
      },

      generateDateFromString: function (StringDate, whenFromNowInDays) {
        var unix = new Date(StringDate);
        if(whenFromNowInDays){
          unix.setDate(unix.getDate() + whenFromNowInDays);
        }
        var selectedDateText = this.formatDate(unix),
          selectedDateJalali = new pdp(unix).format("YYYY-MM-DD");
        return {date: selectedDateText, jalali: selectedDateJalali};
      },

      generateDatePickers: function () {
        var _this = this,
          dpOptions = {
            onSelect: function (unix) {
              var selectedDate = this.model.state.selected,
                $placeHolder = $(this.model.inputElement),
                selectedDateText = _this.formatDate(unix),
                selectedDateJalali = new pdp(unix).format("YYYY-MM-DD");

              $placeHolder.html(selectedDate.year + "/" + selectedDate.month + "/" + selectedDate.date);
              $placeHolder.addClass('travel-search-types__form__dp--has-value');

              if ($placeHolder.data("type") === "in") {
                _this.model['checkin'] = selectedDateText;
                _this.model['checkinJalali'] = selectedDateJalali;
                // _this.model['nights'] = Math.round((_this.parseDate(_this.model['checkout']) - _this.parseDate(_this.model['checkin'])) / (1000 * 60 * 60 * 24));

                var checkout = _this.generateDateFromString(selectedDateText, parseInt(_this.model['nights']));
                _this.model['checkout'] = checkout.date;
                _this.model['checkoutJalali'] = checkout.jalali;

                _this.validateForm();

                _this.persistData({search: _this.model});
                _this.checkInDP.touched = true;
                if (_this.checkOutDP && _this.checkOutDP.options && _this.checkOutDP.options.minDate != unix) {
                  var cachedValue = _this.checkOutDP.getState().selected.unixDate;
                  _this.checkOutDP.options = {minDate: unix + 86400000};
                  if (_this.checkOutDP.touched) {
                    _this.checkOutDP.setDate(cachedValue);
                  }
                }

              } else {
                _this.model['checkout'] = selectedDateText;
                _this.model['checkoutJalali'] = selectedDateJalali;
                _this.model['nights'] = Math.round((_this.parseDate(_this.model['checkout']) - _this.parseDate(_this.model['checkin'])) / (1000 * 60 * 60 * 24));

                _this.validateForm();

                _this.checkOutDP.touched = true;
                if (_this.checkInDP && _this.checkInDP.options && _this.checkInDP.options.maxDate != unix) {
                  var cachedValue = _this.checkInDP.getState().selected.unixDate;
                  _this.checkInDP.options = {maxDate: unix - 86400000};
                  if (_this.checkInDP.touched) {
                    _this.checkInDP.setDate(cachedValue);
                  }
                }
              }
            },
            minDate: new Date(),
            maxDate: null,
            autoClose: true,
            toolbox: {
              calendarSwitch: {
                enabled: false
              }
            }
          };

        var $datePickers = this.$(".tkh-travel-hotel-date-picker");
        $datePickers.each(function () {
          $(this).removeClass('travel-search-types__form__dp--has-value');
          $(this).html($(this).data("ph"));
        });

        if (this.checkInDP) {
          this.checkInDP.options = dpOptions;
        }
        if (this.checkOutDP) {
          this.checkOutDP.options = dpOptions;
        }
        if (!this.checkOutDP || !this.checkInDP) {
          $datePickers.each(function () {
            var dp = $(this).pDatepicker(dpOptions);
            if ($(this).data("type") === "in") {
              _this.checkInDP = dp;
            } else {
              _this.checkOutDP = dp;
            }
          });
        }
      },

      formatDate: function (unix) {
        var currentDate = new Date(unix);
        return (currentDate.getFullYear() + "-" + this.addLeadingZero(currentDate.getMonth() + 1) + "-" + this.addLeadingZero(currentDate.getDate()));
      },

      addLeadingZero: function (n) {
        var s = "0" + n;
        return s.substr(s.length - 2);
      },

      parseDate: function (str) {
        var mdy = str.split('-');
        return new Date(mdy[0], parseInt(mdy[1], 10) - 1, parseInt(mdy[2], 10));
      },

      setModelData: function (e) {
        var $this = $(e.target),
          name = $this.prop('name'),
          attrs = {};

        if (name === 'cityId') {
          var cityData = $this.val().split("-");
          attrs['cityId'] = cityData[0];
          attrs['cityName'] = cityData[1];
        } else {
          attrs[name] = $this.val();
        }
        this.model.set(attrs);
        this.validateForm();
      },

      validateForm: function () {
        if ((this.model.checkin && this.model.checkin !== "") || (this.model.checkout && this.model.checkout !== "")) {
          this.$('.tkh-filter-rooms-search-btn').removeAttr('disabled');
        }
        else {
          this.$('.tkh-filter-rooms-search-btn').attr('disabled', 'disabled');
        }
      },

      renderHotelRooms: function (hotelId) {
        var _this = this,
          persistedData = Lockr.get('travelHotelData');

        if (!persistedData || !persistedData.hotels) {
          this.$el.addClass('travel-hotel-details--no-result');
          return;
        }

        var hotelModel = persistedData.hotels && _.find(persistedData.hotels, function (hotel) {
          return (hotel.id == hotelId);
        });
        if (hotelModel) {
          this.hotelModel = hotelModel;
          this.cartData.hotelId = hotelId;
          this.cartData.hotelName = hotelModel.name;
          this.cartData.hotelAddress = hotelModel.address;

          var search = {
            checkin: this.model.checkout,
            checkinJalali: this.model.checkinJalali,
            checkout: this.model.checkout,
            checkoutJalali: this.model.checkoutJalali,
            person: this.model.person,
            city: this.model.cityName,
            nights: this.model.nights
          };

          hotelModel.room = _.sortBy(hotelModel.room, function(model){
            return model.price;
          });

          this.persistData({search: search});
          $('#hotel__rooms').html(
            _this.template({
              hotel: hotelModel,
              search: search
            })
          );

          var maxDiscounts = _.max(hotelModel.room, function(model){
            return model.disPercentage;
          });
          if(maxDiscounts.disPercentage && maxDiscounts.disPercentage > 0){
            $('.tkh-hotel-discount-badge').show();
            $('.tkh-hotel-discount-badge-value').text("%" + parseInt(maxDiscounts.disPercentage));
          }

          new takhfifan.GoogleMapView({el: $('#map-canvas')});
        } else {
          this.$el.addClass('travel-hotel-details--no-result');
          takhfifan.eventHub.trigger('travel:enable');
        }

        $(".show-facilities-more").click(function () {
          $('#facilitiesIconsDetailPage').toggleClass("all");
        });

        $("#hotel__rooms").removeClass("show-loading");

        $("#readMoreAboutBtn").click(function () {
          $('#readMoreAboutBtn').toggleClass("open");
          $('#readMoreAbout').toggleClass("show-all-about");
        });

      },

      smapleData: function (hotelModel) {
        hotelModel.discount_percentage = 20;
        hotelModel.latLng = "35.7904709,51.4108436";
        hotelModel.description = "بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرامبوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام بوپرام  بوپرام بوپرام بوپرام ";
        hotelModel.facilities = {};
        hotelModel.facilities.parkingIndoor = "1";
        hotelModel.facilities.poolSuana = "1";
        hotelModel.facilities.restaurantBreakfastArea = "1";
        hotelModel.facilities.restaurantBreakfastInRoom = "1";
        hotelModel.facilities.restaurantRoofGarden = "1";
        hotelModel.facilities.restaurantRoomService = "1";
        hotelModel.facilities.lift = "1";
        hotelModel.facilities.laundry = "1";
        hotelModel.facilities.carRental = "1";
        hotelModel.facilities.airportService = "1";

        hotelModel.distanceFromPlace =
          "         لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است<br>" +
          "           لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است<br>" +
          "           لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است<br>" +
          "           لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است<br>" +
          "           لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است<br>" +
          "           لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است<br>" +
          "           لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است<br>" +
          "           لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است<br>" +
          "           لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است<br>";

        _.each(hotelModel.images, function (image) {

          image.images.original = "https://image.ibb.co/fS4FEe/Screenshot_from_2018_08_29_17_57_06.png";
          image.images.thumb = "https://image.ibb.co/cPDxSz/Screenshot_from_2018_08_29_17_57_06.png";

        });
      },

      upRoom: function (e) {
        var $target = $(e.target);
        var $roomCount = $target.parents('.tkh-travel-hotel-room')
          .find('.tkh-travel-hotel-room__rooms');
        var roomCountInt = parseInt($roomCount.text());
        var freeCapacity =
          $target.parents('.tkh-travel-hotel-room').data('freecapacity');
        freeCapacity = parseInt(freeCapacity);
        if (freeCapacity >= roomCountInt + 1) {
          $roomCount.text(parseInt($roomCount.text()) + 1);
        } else {
          takhfifan.eventHub.trigger('message:show', {
            type: 'error',
            msg: "ظرفیت موجود  اتاق" + freeCapacity + " عدد می باشد"
          });
        }
      },

      downRoom: function (e) {
        var $target = $(e.target);
        var $roomCount = $target.parents('.tkh-travel-hotel-room')
          .find('.tkh-travel-hotel-room__rooms');
        var $roomCountInt = parseInt($roomCount.text());
        if ($roomCountInt > 0) {
          $roomCount.text(parseInt($roomCount.text()) - 1);
        }
      },

      reserve: function (e) {
        e.preventDefault();
        var $target = $(e.target),
          $roomCard = $target.parents('.tkh-travel-hotel-room');
        var roomCount = $roomCard.find('.tkh-travel-hotel-room__rooms').text();
        this.cartData.details.push({
          roomId: $roomCard.data('id'),
          rooms: roomCount,
          beds: $roomCard.find('.tkh-travel-hotel-room__beds option:selected').text(),
        });
        if (roomCount > 0) {
          this.changeApplyButtonState($target, false);
          this.disableRoomButtons($roomCard, true);
        } else {
          takhfifan.eventHub.trigger('message:show', {
            type: 'error',
            msg: "لطفا تعداد اتاق درخواستی را انتخاب نمایید"
          });
        }
        this.notifyUser();
      },

      unReserve: function (e) {
        e.preventDefault();
        var $target = $(e.target),
          $roomCard = $target.parents('.tkh-travel-hotel-room'),
          roomId = $roomCard.data('id');

        this.cartData.details = _.without(this.cartData.details, _.findWhere(this.cartData.details, {
          roomId: roomId
        }));

        this.changeApplyButtonState($target, true);
        $roomCard.find('.tkh-travel-hotel-room__rooms').text("1");
        this.disableRoomButtons($roomCard, false);
        this.notifyUser();
      },

      disableRoomButtons: function ($roomCard, disable) {
        if (disable) {
          $roomCard.find('.tkh-travel-hotel-room__count').attr('disabled', "disabled");
          $roomCard.find('.room_extra_beds select').attr('disabled', 'disabled');
        } else {
          $roomCard.find('.tkh-travel-hotel-room__count').removeAttr('disabled');
          $roomCard.find('.room_extra_beds select').removeAttr('disabled');
        }
      },

      changeApplyButtonState: function ($target, toAdd) {
        var $applyBtn = $target.parents('.tkh-travel-hotel-room')
          .find('.tkh-travel-hotel-room__btn');
        var $applybtnLink = $applyBtn.find("a");

        if (toAdd) {
          $applyBtn.removeClass('tkh-travel-hotel-room__un-reserve');
          $applyBtn.addClass('tkh-travel-hotel-room__reserve');
          $applybtnLink.removeClass('remove');
          $applybtnLink.addClass('add');
          $applybtnLink.text('رزرو اتاق');

        } else {
          $applyBtn.removeClass('tkh-travel-hotel-room__reserve');
          $applybtnLink.removeClass('add');
          $applyBtn.addClass('tkh-travel-hotel-room__un-reserve');
          $applybtnLink.addClass('remove');
          $applybtnLink.text('حذف اتاق');
        }
      },

      notifyUser: function () {
        var _this = this,
          totalPrice = 0,
          rooms = 0,
          beds = 0;
        _.each(this.cartData.details, function (item) {
          var roomDetails = _this.hotelModel && _.find(_this.hotelModel.room, function (room) {
            return (room.roomId == item.roomId);
          });
          if (roomDetails) {
            item.description = roomDetails.description + "(" + roomDetails.nameCode + ")";
            totalPrice += roomDetails.price * parseInt(item.rooms);
            rooms += parseInt(item.rooms);
            if (item.beds) {
              totalPrice += roomDetails.rackRate * parseInt(item.beds);
              beds += parseInt(item.beds);
              if (parseInt(item.beds) > 0) {
                item.description += "- همراه " + item.beds + "تخت اضافه";
              }
            }
          }
        });

        if (totalPrice > 0) {
          var template = _.template("" +
            "<%=rooms %> اتاق <%if(beds>0){%> و <%=beds%> تخت اضافه  <% }%> به مبلغ : <%=totalPrice%> ");
          this.$('.tkh-hotel-details__reserve-detail').html(template({
            beds: beds,
            rooms: rooms,
            totalPrice: formatPrice(totalPrice)
          }));
          this.$('.tkh-hotel-details__reserve-btn').removeClass('disabled');
          $('.travel-hotel-details__cart').removeClass("hide");
          this.cartData.totalPrice = totalPrice;
          this.cartData.rooms = rooms;
          this.cartData.beds = beds;
        } else {
          this.cartData.totalPrice= 0;
          this.cartData.rooms= 0;
          this.cartData.beds= 0;
          this.cartData.details= [];
          this.$('.tkh-hotel-details__reserve-detail').html('');
          this.$('.tkh-hotel-details__reserve-btn').addClass('disabled');
          $('.travel-hotel-details__cart').addClass("hide");
        }
        takhfifan.eventHub.trigger('travel:persist-hotel', {cart: this.cartData});
      },

      submit: function (e) {
        // e.preventDefault();
      }

    })
  });

